import {makeAutoObservable} from "mobx";
import {getStore, useStore} from "./index";
import {io} from "socket.io-client";
import {getNotificationStore} from "./NotificationStore";

export class SocketStore {
    store;
    socket = null;
    channels = [];
    connected = false;


    constructor(store) {
        this.store = store;
        this.socket = io(import.meta.env.VITE_REACT_APP_BASE_URL, {
            transports: ['websocket'],
            autoConnect: true,
            auth: {token: localStorage.getItem("token")},
        });
        this.socket?.on("connect", () => { // 연결
            // console.log("socket connect");
        });
        this.socket?.on('notification', (data) => {
            getNotificationStore().addPopup(data)
        });
        this.socket?.on('userNames', (data) => {
            getNotificationStore().setUserNameLists(data)
        });
        this.socket?.on('message', (data) => {
        });
        this.socket.on("disconnect", (reason) => { // 끊켰을때
            // console.log("socket disconnect", reason);
            // this.socket?.off('notification');
            // this.socket?.off('userNames');
            // this.socket?.off('message');
        });
        makeAutoObservable(this, {}, {autoBind: true});
    }

    connect() {
        if (!this.socket.connected) {
            this.socket.connect();
        }
    }

    disconnect() {
        if (this.socket.connected) {
            this.socket.disconnect();
        }
    }

    startPageSession(pageId) {
        this.socket?.emit("startPageSession", {pageId})
    }

    endPageSession(pageId) {
        this.socket?.emit("endPageSession", {pageId})
    }
}

export const useSocketStore = () => {
    return useStore().socketStore;
}

export const getSocketStore = () => {
    return getStore().socketStore;
}
